import { Injectable } from '@angular/core';
import { EAdvancedFilterOptions } from '../../filters-advanced/models/advanced-filter-options.enum';
import { EAdvancedFilterType } from '../../filters-advanced/models/advanced-filter-type.enum';
import { TSearchFilterRow } from '../../filters-advanced/models/advanced-filter.model';
import { filterTypeMatchingOperators } from '../../filters-advanced/utils/advanced-filter-operator.utils';

@Injectable({
  providedIn: 'root',
})
export class FilterContainerService {
  /**
   * API sends the advanced filters in a different format to the component so let's convert it
   * @param advancedFilters
   */
  formatAdvancedFiltersFromAPIResponse(advancedFilters: TSearchFilterRow[]): TSearchFilterRow[] {
    return advancedFilters?.map((filter) => ({
      ...filter,
      item: {
        ...filter.item,
        option: this.pairOptionAndOperator(filter),
        value: filter.values,
        timelinePosition: filter.timelinePosition,
      } as TSearchFilterRow['item'],
    }));
  }

  pairOptionAndOperator(filter: TSearchFilterRow): string {
    const allOptions = filterTypeMatchingOperators[filter.item.type];

    let matchingOption = allOptions.find((option) => option.operator === filter.operator)?.value;

    if (filter.item?.option === EAdvancedFilterOptions.IS_ALL_OF) {
      matchingOption = allOptions.find(
        (option) => option.value === EAdvancedFilterOptions.IS_ALL_OF,
      ).value;
    } else if (filter.item?.option === EAdvancedFilterOptions.IS_NOT_ALL_OF) {
      matchingOption =
        allOptions.find((option) => option.value === EAdvancedFilterOptions.IS_NOT_ALL_OF)?.value ??
        matchingOption;
    } else if (filter.item?.option === EAdvancedFilterOptions.IS_NOT_MULTI) {
      matchingOption =
        allOptions.find((option) => option.value === EAdvancedFilterOptions.IS_NOT_MULTI)?.value ??
        matchingOption;
    } else if (filter.item?.option === EAdvancedFilterOptions.IS_NONE_OF) {
      matchingOption =
        allOptions.find((option) => option.value === EAdvancedFilterOptions.IS_NONE_OF)?.value ??
        matchingOption;
    } else if (filter.item?.option === EAdvancedFilterOptions.IS_ANY_OF) {
      matchingOption =
        allOptions.find((option) => option.value === EAdvancedFilterOptions.IS_ANY_OF)?.value ??
        matchingOption;
    } else if (filter.item?.option === EAdvancedFilterOptions.IS_EMPTY) {
      switch (filter.item.type) {
        case EAdvancedFilterType.CHECKBOX: {
          matchingOption = allOptions.find(
            (option) => option.value === EAdvancedFilterOptions.IS_NOT_CHECKED,
          ).value;

          break;
        }
        default:
          matchingOption = allOptions.find(
            (option) => option.value === EAdvancedFilterOptions.IS_EMPTY,
          ).value;

          break;
      }
    } else if (
      (filter.values[0] === null || Array.isArray(filter.values[0])) &&
      filter.item?.option !== EAdvancedFilterOptions.IS
    ) {
      matchingOption = allOptions
        .filter((option) => option.operator === filter.operator)
        .find((option) => option.data).value;
    }

    return matchingOption;
  }
}
